import { BoschAxios } from "../api/BoschAxios";
import { buildUrl } from "../redux/api";
import UserService from "./UserService";

type GetUserParams = {
  email?: string;
  page?: number;
};

export const getUsersRequest = async (route: string, data: GetUserParams) => {
  const baseRequest = await buildUrl({ route });
  const token = UserService.getToken();

  const params = new URLSearchParams();

  if (data?.email) params.append("email", data.email);
  if (data?.page) params.append("page", String(data.page));

  const query = params.toString();
  const url = query ? `${baseRequest.route}?${query}` : baseRequest.route;

  return BoschAxios(url, baseRequest.method, null, token);
};